module.exports = __webpack_public_path__ + "img/private.eb4bfcd.png";